/* eslint-disable react/prop-types */
/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import useTimeline from '../timeline/useTimeline';

export default function ErrorNotification() {
  const [state] = useState({
    vertical: 'bottom',
    horizontal: 'center',
    alertDuration: 5000,
  });

  const { alertMessage, setAlertMessage } = useTimeline();
  if (!alertMessage) return null;

  const { vertical, horizontal, alertDuration } = state;

  return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      key={`${vertical},${horizontal}`}
      open={alertMessage != null}
      autoHideDuration={alertDuration}
      onClose={() => setAlertMessage(null)}
      ContentProps={{
        'aria-describedby': 'message-id',
      }}
      message={<span id="message-id">{alertMessage.message}</span>}
    />
  );
}
